import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';

export default function Vision({ dark }) {
  const ref = useFadeIn();

  return (
    <section id="vision" className={`py-24 px-6 ${dark ? 'bg-[#0d1a0f]' : 'bg-white'}`}>
      <div className="max-w-6xl mx-auto" ref={ref}>
        <div className="text-center max-w-2xl mx-auto mb-14 fade-in">
          <span className={`inline-block text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5
            ${dark ? 'bg-green-400/10 text-green-400' : 'bg-green-100 text-green-800'}`}>
            Our Purpose
          </span>
          <h2 className={`font-serif text-3xl md:text-4xl font-bold leading-tight mb-4 ${dark ? 'text-white' : 'text-green-900'}`}>
            Guided by Vision, Driven by Mission
          </h2>
          <div className="w-14 h-0.5 bg-green-600 mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 fade-in">
          {[
            {
              label: 'Vision',
              text: 'To become a leading and globally recognized agricultural enterprise committed to sustainable food production, innovation, and transforming lives through agriculture.',
            },
            {
              label: 'Mission',
              text: 'At Global Exclusive Ariel Farm Ltd, our mission is to produce high-quality agricultural products through sustainable and modern farming practices, while empowering communities, creating employment opportunities, and contributing to food security. We are dedicated to giving back to humanity by improving livelihoods and promoting a healthier society through our agricultural initiatives.',
            },
          ].map(item => (
            <div key={item.label}
              className={`border rounded-2xl p-10 ${dark ? 'bg-green-900/20 border-green-400/10' : 'bg-green-50/70 border-green-800/10'}`}
            >
              <div className={`flex items-center gap-3 text-xs font-bold tracking-widest uppercase mb-6 ${dark ? 'text-green-400' : 'text-green-600'}`}>
                <span className="w-5 h-0.5 bg-current" />
                {item.label}
              </div>
              <p className={`font-serif text-lg italic leading-relaxed ${dark ? 'text-green-100' : 'text-green-900'}`}>
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* Core Values chips */}
        <div className="mt-16 fade-in text-center">
          <p className={`text-xs font-semibold tracking-widest uppercase mb-6 ${dark ? 'text-green-600' : 'text-green-500'}`}>Core Values</p>
          <div className="flex flex-wrap justify-center gap-3">
            {['Integrity', 'Community Impact', 'Sustainability', 'Quality & Excellence', 'Innovation', 'Integrity & Transparency', 'Responsibility & Stewardship', 'Partnership & Growth'].map(v => (
              <span key={v}
                className={`text-sm font-medium px-5 py-2 rounded-full border transition-all duration-200
                  ${dark
                    ? 'bg-green-900/30 border-green-400/15 text-green-300 hover:bg-green-400/10'
                    : 'bg-white border-green-800/15 text-green-800 hover:bg-green-50 hover:border-green-600'}`}
              >
                {v}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
